import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { Button, Card, Drawer, Form, notification, Select, Switch, Tabs, Tooltip, Row, Col, Input, List, } from 'antd'
import _ from 'lodash'

import { hideLoader, showLoader } from '../../modules/actions'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import styles from '../Desk/registration/all/styles.less'
import { getUrlPushWrapper } from '../../routes'
import commonStyle from './../common.less'
import setting from './../../components/_utils/settings'
import moment from 'moment'
import Moment from 'moment'

import { FaUserCog } from "react-icons/fa";

const Option = Select.Option

const TabPane = Tabs.TabPane

// following variables needed for update country

@Form.create()
class ChangePassword extends Component {
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                this.props.handleSubmit(valData)
            }
        })
    }

    render() {
        const { dispatch } = this.props

        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props

        let inputTypes = {
            fields: [
                {
                    label: 'Password',
                    key: 'password',
                    type: 'password',
                    required: true
                },
                {
                    label: 'Confirm Password',
                    key: 'cpassword',
                    type: 'password',
                    required: true
                }
            ]
        }

        return (
            <div>
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <GetAllFormFields
                        inputSchema={inputTypes}
                        getFieldDecorator={getFieldDecorator}
                    />
                    <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginBottom: 10, marginLeft: '33%' }}
                        loading={this.props.loading}>
                        SAVE
                    </Button>
                </Form>
            </div>
        )
    }
}

@Form.create()
class User extends PureComponent {
    callback = key => {
        if (key == 2 && this.state.bankInfo) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    ...this.state.bankInfo
                });
                this.setState({ bankInfo: '' });
            }, 200);
        }
    }

    loadUsers = (params, userType = 'user') => {
        return new Promise(async resolve => {
            if (!params) {
                params = {}
            }
            params.sortField = '_id'
            params.sortOrder = 'ascend'

            if (this.state.isActive)
                params.active = true
            else
                params.active = null

            if (userType == 'student') {
                params.userType = "Student"
            } else {
                params.userType = { $ne: "Student" }
            }
            params.options = "all";
            let data = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
            if (userType == 'student') {
                this.setState({ totalStudents: data.total })
            } else {
                this.setState({ totalUser: data.total })
            }

            resolve(data)
        })
    }

    loadBranches = () => {
        let params = { sortField: 'branchName', sortOrder: 'ascend' }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.branchName })
                    return temp
                }, [])
                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][0].options = resp.data
                this.setState({ inputTypes: inputTypes, branchesData: resp.data })
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader())
                let x = null
                if (this.state.seniorityBonus.length > 0) {
                    const seniorityBonus = this.state.seniorityBonus.map(el => this.clean(el));
                    values.seniorityBonus = seniorityBonus;
                } else {
                    values.seniorityBonus = [];
                }

                if (this.state.operationManagerIncentive.length > 0) {
                    const operationManagerIncentive = this.state.operationManagerIncentive.map(el => this.clean(el));
                    values.operationManagerIncentive = operationManagerIncentive;
                } else {
                    values.operationManagerIncentive = [];
                }
                const bankInfo = {
                    bankName: values.bankName, branchNameAddress: values.branchNameAddress, accountNumber: values.accountNumber,
                    accountName: values.accountName, ifsc: values.ifsc
                };
                values.bankDetails = bankInfo;
                this.setState({ bankInfo: bankInfo });
                values._id = this.state.id;
                delete values.bankName;
                delete values.branchNameAddress;
                delete values.accountName;
                delete values.accountNumber;
                delete values.ifsc;
                if (this.state.id) {
                    x = await Request.updateUser(values)
                } else {
                    x = await Request.addUser(values)

                }
                dispatch(hideLoader())
                if (!x.error) {
                    if (!this.state.id) {
                        form.resetFields()
                    }
                    notification.success({
                        message: this.state.id
                            ? `User Updated Successfully`
                            : 'User Added successfully'
                    })

                    if (this.table && this.table.current) this.table.current.reload()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    loadGroups = () => {
        let params = {
            results: 100,
            sortField: 'groupName',
            sortOrder: 'ascend'
        }
        Request.loadGroups(params).then(resp => {
            if (resp && resp.result) {
                resp.result = resp.result.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.groupName })
                    return temp
                }, [])
                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][4].options = resp.result
                this.setState({ inputTypes: inputTypes })
                this.refreshFxn()
            }
        })
    }

    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountries(params)
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Select All---', id: 'all' }];
                    let phoneCodes = [];
                    resp.data = resp.data.reduce((el, vv) => {
                        if (vv.countryPhoneCode) {
                            phoneCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode });
                        }
                        vv.display = vv.countryName
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, [])

                    this.setState({ countries: resp.data, phoneCodes })
                }
            })
            .catch(err => {
            })
    }

    loadShiftTiming = async () => {
        let params = {
            results: 1000,
            count: 1000
        }
        let shiftTimings = []
        let response = await Request.getAllShiftTimings(params)
        _.each(response.data, (item) => {
            shiftTimings.push({ id: item.shiftTime, display: item.shiftTime })
        })
        this.setState({ shiftTimings: shiftTimings })
    }


    loadAllCounsellorUsers = () => {
        let params = {
            results: 100,
            sortField: 'name',
            sortOrder: 'ascend'
        }
        Request.getCounsellorUsers(params)
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Select All---', id: 'all' }];
                    resp.data = resp.data.reduce((el, vv) => {
                        vv.display = vv.name
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, [])

                    this.setState({ counsellors: resp.data })
                }
            })
            .catch(err => {
            })
    }

    changeUserApporval = async ({ checked, _id }) => {
        let response = await Request.approveUser({ _id, active: checked })
        if (response.error) {
            notification.error({
                message: response.message
            })
        } else {
            notification.success({
                message: 'User Updated'
            })
        }
        this.reload();
    }

    changeUserCounsellor = async ({ checked, _id }) => {
        await Request.changeUserCounsellor({ _id, isCounsellor: checked })
        this.reload();
    }

    assignUserTelecaller = async ({ checked, _id }) => {
        await Request.assignUserTelecaller({ _id, isTelecaller: checked })
        this.reload();
    }

    changeLoginByOTPOnly = async ({ checked, _id }) => {
        await Request.changeLoginByOTPOnly({ _id, loginByOTPOnly: checked })
        this.reload();
    }
    changeVerifyIPOnly = async ({ checked, _id }) => {
        await Request.changeVerifyIPOnly({ _id, verifyIP: checked })
        this.reload();
    }

    changeEditedByUser = async ({ checked, _id }) => {
        await Request.changeEditedByUser({ _id, editedByUser: checked })
        this.reload()
    }

    changeIsOperationManager = async ({ checked, _id }) => {
        await Request.changeIsOperationManager({ _id, isOperationManager: checked })
        this.reload();
    }

    onOk = value => {
        this.reload()
    }
    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {
        super(props)
        this.state = {
            openUserSessionDrawr: false,
            loginUrl: '',
            showSave: 1,
            expierenceLetterIssued: false,
            showFiles: 0,
            totalUser: 0,
            totalStudents: 0,
            isActive: true,
            refreshChild: false,
            userArr: [],
            rightArr: [],
            groupArr: [],
            branchArr: [],
            allBranches: [],
            allUserGroup: [],
            userGroupArr: [],
            countries: [],
            branchesData: [],
            hodList: [],
            counsellors: [],
            departments: [],
            userByBranchId: '',
            userByGroupId: '',
            incentiveTypes: [{ id: 'DIRECT', display: 'Direct' }, { id: 'ASSOCIATE_PARTNER', display: 'Associate Partner/Branch' },
            { id: 'FLC', display: 'FLC' }],
            seniorityBonus: [],
            operationManagerIncentive: [],
            type: '',
            isOperationManager: false,
            operationManagerType: '',
            editIndex: null,
            seniorityBonusFlatAmount: '',
            editIndexOperationManager: null,
            operationManagerFlatAmount: '',
            bankInfo: '',
            isHRPanel: false,
            activeStatus: '',
            releivingAvialable: false,
            allUsers: [],
            shiftTimings: [],
            companyDetail: {},
            activeUser: {},
            maritalStatus: [],
            phoneCodes: [],
            workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            ishod: false,
            inputTypes: [
                {
                    tabTitle: 'NEW USER',
                    fields: [
                        {
                            label: 'Branch ',
                            key: 'userBranch',
                            required: true,
                            type: 'select',
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    userBranch: v
                                })
                            }
                        },
                        { label: 'Name', key: 'name', required: true },
                        { label: 'Email', key: 'email', required: true },
                        { label: 'Mobile', key: 'mobile', required: true },
                        {
                            label: 'Select Group',
                            key: 'userGroup',
                            required: true,
                            type: 'select',
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({ userGroup: v })
                            }
                        },
                        {
                            label: 'Select Type',
                            key: 'userType',
                            required: true,
                            type: 'select',
                            options: ['Branch Type', 'Branch', 'Admin'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    userType: v
                                })
                            }
                        }
                    ]
                }
            ]
        }
        this.table = React.createRef()
        this.loadBranches()
        this.loadUsers()
        this.loadShiftTiming()
        this.loadAllCountries()
        this.loadAllCounsellorUsers()
    }

    async loadMaritalStatus() {
        let params = {
            count: 1000,
            results: 1000
        }
        let response = await Request.getMaritalStatusDetails(params)
        let maritalStatus = []
        _.each(response.data, (item) => {
            maritalStatus.push({ id: item.maritalStatus, display: item.maritalStatus })
        })
        this.setState({ maritalStatus })
    }
    fetchAllHod = async () => {
        let params = {}
        params.sortField = 'dateOfJoining'
        params.sortOrder = 'ascend'
        params.active = true
        params.userType = { $ne: "Student" }
        params.isHOD = true
        let { data } = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
        let hodList = []
        _.each(data, (item) => {
            hodList.push({ _id: item._id, display: item.name })
        })
        this.setState({ hodList })
    }

    getCurrentUser = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user'))
        this.setState({
            activeUser: activeUser
        });
        let companyDetail = await Request.getCompanySetting({ businessId: activeUser.businessId })
        this.setState({
            companyDetail: companyDetail,
        });
    }

    async loadDepartments() {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllDepartments(params);
        let departments = []
        _.each(response.data, (item) => {
            departments.push({ id: item.departmentName, display: item.departmentName })
        })
        this.setState({ departments })
    }

    async componentDidMount() {
        let allUsers = []
        const { dispatch } = this.props
        let params = {
            results: 200,
            count: 200
        }
        this.loadMaritalStatus()
        this.loadDepartments()
        this.fetchAllHod()
        await this.getCurrentUser()
        let users = await this.loadUsers(params, 'user')
        users.data.map((user) => {
            allUsers.push({ _id: user._id, display: user.name })
        })
        this.setState({ allUsers })
        let searchParams = new URLSearchParams(this.props.search)
        let userId = searchParams.get('id')
        this.setState({
            id: userId
        })

        dispatch(showLoader())

        let { data: branchArr } = await Request.getAllSimpleBranch({ results: 10000, sortField: 'branchName', sortOrder: 'ascend', status: true })
        let allBranches = []
        _.each(branchArr, (item) => {
            allBranches.push({ value: item._id, text: item.branchName })
        })
        this.setState({ branchArr, allBranches })

        let { data: userGroupArr } = await Request.loadGroups({ results: 10000, sortField: 'groupName', sortOrder: 'ascend' })
        let allUserGroup = []
        _.each(userGroupArr, (item) => {
            allUserGroup.push({ value: item._id, text: item.groupName })
        })
        this.setState({ userGroupArr, allUserGroup })


        if (userId) {
            Request.getUserById({ id: userId }).then(({ _doc: data, error, message }) => {
                if (!error) {
                    this.setState({
                        id: data._id
                    })
                    if (data.experienceLetter === "Issued") {
                        this.setState({ expierenceLetterIssued: true })
                    }
                    if (data.dateOfRelieving) {
                        this.setState({ releivingAvialable: true })
                    }
                    if (data.isHRManager) {
                        this.setState({ isHRPanel: true })
                    }
                    if (data.isOperationManager) {
                        this.setState({ isOperationManager: true })
                    }

                    this.setState({ activeStatus: (data && data.activeStatus) })
                    if (data.isHOD === true) {
                        this.setState({ ishod: true })
                    }
                    this.props.form.setFieldsValue({
                        email: data && data.email,
                        userGroup: data && data.userGroup && data.userGroup._id,
                        name: data && data.name,
                        userMobile: data && data.userMobile,
                        userMobileCode: data && data.userMobileCode,
                        userBranch: data && data.userBranch && data.userBranch._id,
                        countryIds: data && data.countryIds,
                        counsellorIds: data && data.counsellorIds,
                        isCounsellor: data && data.isCounsellor,
                        isFrontDesk: data && data.isFrontDesk,
                        isTelecaller: data && data.isTelecaller,
                        isAdmission: data && data.isAdmission,
                        isRegistration: data && data.isRegistration,
                        isVisa: data && data.isVisa,
                        isClaim: data && data.isClaim,
                        isAccount: data && data.isAccount,
                        loginByOTPOnly: data && data.loginByOTPOnly,
                        verifyIP: data && data.verifyIP,
                        editedByUser: data && data.editedByUser,
                        isOperationManager: data && data.isOperationManager,
                        incentiveOperationManager: data && data.incentiveOperationManager,
                        isManageTMasterLeads: data && data.isManageTMasterLeads,
                        isHRManager: data && data.isHRManager,
                        branchesManaging: data && data.branchesManaging,
                        isBranchHead: data && data.isBranchHead,
                        isFinanceAdmin: data && data.isFinanceAdmin,
                        isHOD: data && data.isHOD,
                        userHOD: data && data.userHOD,
                        teamIds: data && data.teamIds,
                        experienceCert: data && data.experienceCert,
                        relievingCert: data && data.relievingCert,
                        noDueCert: data && data.noDueCert,
                        isVisitorVisaCounsellor: data && data.isVisitorVisaCounsellor,
                        appointmentCert: data && data.appointmentCert,
                        employeeAgreementCert: data && data.employeeAgreementCert,
                        shiftTiming: data && data.shiftTiming,
                        workingDays: data && data.workingDays,
                        incentiveTerm: data && data.incentiveTerm,
                        permanentAddress: data && data.permanentAddress,
                        temporaryAddress: data && data.temporaryAddress,
                        dob: data && Moment(data.dob),
                        personalEmail: data && data.personalEmail,
                        contactNo: data && data.contactNo,
                        emergencyPhone: data && data.emergencyPhone,
                        maritalStatus: data && data.maritalStatus,
                        empId: data && data.empId,
                        department: data && data.department,
                        isAdministrator: data && data.isAdministrator,
                        hireAs: data && data.hireAs,
                        highestQualification: data && data.highestQualification,
                        nameOfInstitute: data && data.nameOfInstitute,
                        previousDesignation: data && data.previousDesignation,
                        previousExperience: data && data.previousExperience,
                        previousSalary: data && data.previousSalary,
                        dateOfJoining: data && Moment(data.dateOfJoining),
                        joiningSalary: data && data.joiningSalary,
                        activeStatus: data && data.activeStatus,
                        resignationDate: data && Moment(data.resignationDate),
                        terminationDate: data && Moment(data.terminationDate),
                        abscondDate: data && Moment(data.abscondDate),
                        dateOfRelieving: data && Moment(data.dateOfRelieving),
                        fullFinalSettlementDue: data && data.fullFinalSettlementDue,
                        experienceLetter: data && data.experienceLetter,
                        bankName: data && data.bankDetails && data.bankDetails.bankName,
                        branchNameAddress: data && data.bankDetails && data.bankDetails.branchNameAddress,
                        accountNumber: data && data.bankDetails && data.bankDetails.accountNumber,
                        ifsc: data && data.bankDetails && data.bankDetails.ifsc,
                        accountName: data && data.bankDetails && data.bankDetails.accountName,
                    }, () => {
                        this.props.form.setFieldsValue({ counsellorTarget: data && data.counsellorTarget, })
                    });

                    this.setState({
                        bankInfo: {
                            bankName: data && data.bankDetails && data.bankDetails.bankName,
                            branchNameAddress: data && data.bankDetails && data.bankDetails.branchNameAddress,
                            accountNumber: data && data.bankDetails && data.bankDetails.accountNumber,
                            accountName: data && data.bankDetails && data.bankDetails.accountName,
                            ifsc: data && data.bankDetails && data.bankDetails.ifsc
                        }
                    })
                    if (data && data.seniorityBonus && data.seniorityBonus.length > 0) {
                        this.setState({ seniorityBonus: data.seniorityBonus })
                    }
                    if (data && data.operationManagerIncentive && data.operationManagerIncentive.length > 0) {
                        this.setState({ operationManagerIncentive: data.operationManagerIncentive })
                    }


                } else {
                    notification.error({
                        message: 'Error Getting Data',
                        description: message
                    })
                }
            })
        }

        dispatch(hideLoader())
    }

    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    //------------- types

    addToStages = () => {
        if (!this.state.type) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.seniorityBonusFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Seniority Bonus Flat Amount is required'
            })
            return false;
        }
        let tempArr = this.state.seniorityBonus
        tempArr.push({
            type: this.state.type,
            seniorityBonusFlatAmount: this.state.seniorityBonusFlatAmount,
        })
        this.setState({ seniorityBonus: tempArr, type: null, incentivePercentage: null, seniorityBonusFlatAmount: null })
    }

    addToOperationManagerStages = () => {
        if (!this.state.operationManagerType) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.operationManagerFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Operation Manager Flat Amount is required'
            })
            return false;
        }
        let tempArr = this.state.operationManagerIncentive
        tempArr.push({
            operationManagerType: this.state.operationManagerType,
            operationManagerFlatAmount: this.state.operationManagerFlatAmount,
        })
        this.setState({ operationManagerIncentive: tempArr, operationManagerType: null, incentivePercentage: null, operationManagerFlatAmount: null })
    }

    editStages = (row, index) => {
        this.setState({ type: row.type, incentivePercentage: row.incentivePercentage, seniorityBonusFlatAmount: row.seniorityBonusFlatAmount, editIndex: index })
    }

    editOperationManagerStages = (row, index) => {
        this.setState({ operationManagerType: row.operationManagerType, operationManagerFlatAmount: row.operationManagerFlatAmount, editIndexOperationManager: index })
    }

    updateStage = () => {
        if (!this.state.type) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.incentivePercentage && !this.state.seniorityBonusFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Incentive Percentage or Amount is required'
            })
            return false;
        }
        let { editIndex, type, incentivePercentage, seniorityBonusFlatAmount } = this.state;
        let tempArr = this.state.seniorityBonus;
        tempArr[editIndex] = {
            type: type,
            seniorityBonusFlatAmount: seniorityBonusFlatAmount
        };
        this.setState({ seniorityBonus: tempArr, type: null, seniorityBonusFlatAmount: null, editIndex: null })
    }

    updateOperationManageStage = () => {
        if (!this.state.operationManagerType) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.operationManagerFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Operation Manager Flat Amount in required'
            })
            return false;
        }
        let { editIndexOperationManager, operationManagerType, operationManagerFlatAmount } = this.state;
        let tempArr = this.state.operationManagerIncentive;
        tempArr[editIndexOperationManager] = {
            operationManagerType: operationManagerType,
            operationManagerFlatAmount: operationManagerFlatAmount
        };
        this.setState({ operationManagerIncentive: tempArr, operationManagerType: null, operationManagerFlatAmount: null, editIndexOperationManager: null })
    }

    renderStatus = (val) => {
        if (val === "DIRECT") {
            return <div >{'Direct'}</div>;
        }
        if (val === "ASSOCIATE_PARTNER") {

            return <div >{'Associate Partner/Branch'}</div>;
        }

        if (val === "FLC") {
            return <div >{'FLC'}</div>;
        }
    };

    removeIn = sss => {
        let arr = this.state.seniorityBonus
        arr = arr.filter((val, i) => i !== sss)
        this.setState({ seniorityBonus: arr })
    }

    removeOperationMangerIncentive = sss => {
        let arr = this.state.operationManagerIncentive
        arr = arr.filter((val, i) => i !== sss)
        this.setState({ operationManagerIncentive: arr })
    }

    // syncUserSession = async (email) => {
    //     let resp = await Request.syncUserSessionWithLogin({ email });
    //     var path = `${window.location.protocol}//${window.location.host}/login?authorization=${resp.access_token}&verify=no`;
    //     this.setState({ openUserSessionDrawr: true, loginUrl: path })
    // }

    syncUserSession = async (email) => {
        try {
            // let resp = await Request.syncUserSessionWithLogin({ email });
            let resp = await Request.getImpersonationLink({ email });
            const path = `${window.location.protocol}//${window.location.host}/login?impersonate=${resp.access_token}`;
            // const path = `${window.location.protocol}//${window.location.host}/login?authorization=${resp.access_token}&verify=no`;

            // Copy link to clipboard
            await navigator.clipboard.writeText(path);

            // Optional: show notification that link is copied
            notification.success({
                message: 'Link Copied',
                description: 'The login link has been copied to clipboard!',
            });
        } catch (err) {
            console.error(err);
            notification.error({
                message: 'Error',
                description: 'Failed to copy login link.',
            });
        }
    }


    render() {
        const {
            dispatch,
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props
        let {
            openUserSessionDrawr,
            loginUrl,
            allBranches = [],
            allUserGroup = [],
            drawerVisible,
            changePasswordRecord,
            id,
            seniorityBonus,
            type,
            incentiveTypes,
            seniorityBonusFlatAmount,
            operationManagerType,
            operationManagerFlatAmount,
            operationManagerIncentive,
            activeStatus,
            expierenceLetterIssued,
            releivingAvialable,
            shiftTimings,
            workingDays,
            companyDetail,
            isHRPanel,
            branchesData,
            hodList,
            departments
        } = this.state
        let inputTypes = {
            fields: [
                {
                    label: 'Branch ',
                    key: 'userBranch',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Branch',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.branchName,
                    type: 'select',
                    disabled: false,
                    options: this.state.branchArr ? this.state.branchArr : [],
                    onChange: branch => {
                        setFieldsValue({
                            userBranch: branch
                        })
                    }
                },
                { label: 'Name', key: 'name', required: true },
                { label: ' User Email', key: 'email', required: true },
                {
                    label: ' User Department', key: 'department', required: true, type: "select", options: departments, onChange: v => {
                        this.props.form.setFieldsValue({ department: v })
                    }
                },
                {
                    label: 'Password',
                    key: 'password',
                    type: 'password',
                    hidden: (id ? true : false)
                },
                {
                    label: 'Official Mobile Phone Code',
                    key: 'userMobileCode',
                    showSearch: true,
                    required: true,
                    type: 'select',
                    options: this.state.phoneCodes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ userMobileCode: v })
                    }
                },
                {
                    label: 'Official Mobile No  ',
                    key: 'userMobile',
                    required: true,
                    type: 'Number'
                },
                {
                    label: 'User Group',
                    key: 'userGroup',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Group',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.groupName,
                    type: 'select',
                    disabled: false,
                    options: this.state.userGroupArr ? this.state.userGroupArr : [],
                    onChange: group => {
                        setFieldsValue({
                            userGroup: group
                        })
                    }
                },
                {
                    label: 'Incentive Term',
                    key: 'incentiveTerm',
                    type: 'select',
                    options: ["Monthly", "Quaterly", "Half-Yearly", "Yearly"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ incentiveTerm: v })
                    }
                },
                {
                    label: 'Operation Manager Desk',
                    key: 'isOperationManager',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isOperationManager: v
                        })
                        this.setState({ isOperationManager: v })
                    }
                },
                {
                    label: 'Operation Manager Incentive',
                    key: 'incentiveOperationManager',
                    type: 'switch',
                    hidden: !this.state.isOperationManager,
                    onChange: v => {
                        setFieldsValue({ incentiveOperationManager: v })
                    }
                },
                {
                    label: 'Manage T Master Leads',
                    key: 'isManageTMasterLeads',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isManageTMasterLeads: v
                        })
                    }
                },
                {
                    label: 'Front Desk',
                    key: 'isFrontDesk',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isFrontDesk: v
                        })
                    }
                },
                {
                    label: 'Counselling Desk',
                    key: 'isCounsellor',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isCounsellor: v
                        })
                    }
                },
                {
                    label: 'Counsellor Target',
                    key: 'counsellorTarget',
                    type: 'number',
                    hidden: getFieldValue('isCounsellor') ? false : true
                },
                {
                    label: 'Target Period',
                    key: 'counsellorTargetPeriod',
                    type: 'select',
                    hidden: getFieldValue('isCounsellor') ? false : true,
                    options: ["Monthly", "Quaterly", "Half-Yearly", "Yearly"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ counsellorTargetPeriod: v })
                    }
                },
                {
                    label: 'Countries Handled By User',
                    key: 'countryIds',
                    required: false,
                    type: 'select',
                    mode: 'multiple',
                    options: this.state.countries ? this.state.countries : [],
                    showSearch: true,
                    defaultValue: { key: 'Please Select' },
                    optionFilterProp: 'selectCountry',
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === this.state.countries.length) {
                                val = [];
                            } else {
                                val = this.state.countries.slice(1).map(country => country.id);
                            }
                        }
                        setFieldsValue({
                            countryIds: val
                        })
                    }
                },
                {
                    label: 'Team Members ',
                    key: 'counsellorIds',
                    required: false,
                    type: 'select',
                    mode: 'multiple',
                    options: this.state.counsellors ? this.state.counsellors : [],
                    showSearch: true,
                    defaultValue: { key: 'Please Select' },
                    optionFilterProp: 'select Counsellor',
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === this.state.counsellors.length) {
                                val = [];
                            } else {
                                val = this.state.counsellors.slice(1).map(counsellor => counsellor.id);
                            }
                        }
                        setFieldsValue({
                            counsellorIds: val
                        })
                    }
                },
                {
                    label: 'Registration Desk',
                    key: 'isRegistration',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isRegistration: v
                        })
                    }
                },
                {
                    label: 'Admissions Desk',
                    key: 'isAdmission',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isAdmission: v
                        })
                    }
                },

                {
                    label: 'Visa Desk',
                    key: 'isVisa',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isVisa: v
                        })
                    }
                },
                {
                    label: 'Claim Desk',
                    key: 'isClaim',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isClaim: v
                        })
                    }
                },

                {
                    label: 'Account Desk',
                    key: 'isAccount',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isAccount: v
                        })
                    }
                },

                {
                    label: 'Finance Director',
                    key: 'isFinance',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isFinance: v
                        })
                    }
                },
                {
                    label: 'Relationship Manager',
                    key: 'isRelationshipManager',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isRelationshipManager: v
                        })
                    }
                },
                {
                    label: 'HR Manager',
                    key: 'isHRManager',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isHRManager: v
                        })
                        this.setState({ isHRPanel: v })
                    }
                },
                {
                    label: 'Branches Managing',
                    key: 'branchesManaging',
                    type: 'select',
                    hidden: !isHRPanel,
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.branchName,
                    showSearch: true,
                    mode: 'multiple',
                    options: this.state.branchArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({ branchesManaging: v })
                    }
                },
                {
                    label: 'Branch Head',
                    key: 'isBranchHead',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isBranchHead: v
                        })
                    }
                },
                {
                    label: 'Finance Admin',
                    key: 'isFinanceAdmin',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isFinanceAdmin: v
                        })
                    }
                },
                {
                    label: 'Is Administrator',
                    key: 'isAdministrator',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isAdministrator: v
                        })
                    }
                },
                {
                    label: 'Employee HOD',
                    key: 'userHOD',
                    type: 'select',
                    options: hodList,
                    hidden: this.state.ishod || companyDetail && !companyDetail.haveHeadOfDepartments,
                    mode: 'multiple',
                    onChange: v => {
                        this.props.form.setFieldsValue({ userHOD: v })
                    }
                },
                {
                    label: 'Is HOD',
                    key: 'isHOD',
                    type: 'switch',
                    hidden: companyDetail && !companyDetail.haveHeadOfDepartments,
                    onChange: v => {
                        setFieldsValue({
                            isHOD: v
                        })
                        if (v === true) {
                            this.setState({ ishod: true })
                        } else if (v === false) {
                            this.setState({ ishod: false })
                        }
                    }
                },
                {
                    label: 'Select Team',
                    key: 'teamIds',
                    type: 'select',
                    options: this.state.allUsers,
                    hidden: !this.state.ishod,
                    mode: 'multiple',
                    showSearch: true,
                    onChange: val => {
                        this.props.form.setFieldsValue({ teamIds: val })
                    }
                },
                {
                    label: 'Is Visitor Visa Counsellor',
                    key: 'isVisitorVisaCounsellor',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isVisitorVisaCounsellor: v
                        })
                    }
                },
                {
                    label: 'Login By OTP Only',
                    key: 'loginByOTPOnly',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            loginByOTPOnly: v
                        })
                    }
                },

                {
                    label: 'Verify IP',
                    key: 'verifyIP',
                    type: 'switch',
                    hidden: this.state.activeUser && (this.state.activeUser.businessId === "1035"),
                    onChange: v => {
                        setFieldsValue({
                            verifyIP: v
                        })
                    }
                },
                {
                    label: 'Profile Edited',
                    key: 'editedByUser',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            editedByUser: v
                        })
                    }
                },
            ]
        }

        let inputTypeBankDetails = {
            fields: [
                { label: 'Bank Name', key: 'bankName', required: false },
                { label: 'Branch Name & Address', key: 'branchNameAddress', required: false },
                { label: 'Account No', key: 'accountNumber', required: false },
                { label: 'Account Name', key: 'accountName', required: false },
                { label: 'IFSC Code', key: 'ifsc', required: false },
            ]
        }

        let inputTypePersonalInfo = {
            fields: [
                { label: 'Permanent Address', key: 'permanentAddress', type: 'textarea' },
                { label: 'Temporary Address', key: 'temporaryAddress', type: 'textarea' },
                { label: 'Date Of Birth', key: 'dob', type: 'date' },
                { label: 'Personal Email', key: 'personalEmail', type: 'email' },
                { label: 'Contact Number', key: 'contactNo', type: 'number', style: { width: "100%" } },
                { label: 'Emergency Number', key: 'emergencyPhone', type: 'number', style: { width: "100%" } },
                {
                    label: 'Marital Status',
                    key: 'maritalStatus',
                    type: 'select',
                    options: this.state.maritalStatus,
                    placeholder: 'Select Marital Status',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            maritalStatus: v
                        })
                    }
                },
                { label: 'Employee ID', key: 'empId' },
                { label: 'Hire AS', key: 'hireAs' },
                { label: 'Highest Qualification', key: 'highestQualification' },
                { label: 'Name Of Institution', key: 'nameOfInstitute' },
                { label: 'Previous Experience', key: 'previousExperience' },
                { label: 'Previous Designation', key: 'previousDesignation' },
                { label: 'Previous Salary', key: 'previousSalary', type: 'number', style: { width: "100%" } },
                { label: 'Date of Joining', key: 'dateOfJoining', type: 'date', style: { width: "100%" } },
                { label: 'Appointment Letter', key: 'appointmentCert', type: 'file' },
                { label: 'Employee Agreement', key: 'employeeAgreementCert', type: 'file' },
                {
                    label: 'Shift Timing',
                    key: 'shiftTiming',
                    type: 'select',
                    options: shiftTimings,
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            shiftTiming: v
                        })
                    }
                },
                {
                    label: 'Working Days',
                    key: 'workingDays',
                    type: 'select',
                    required: true,
                    mode: 'multiple',
                    options: workingDays,
                    onChange: v => {
                        this.props.form.setFieldsValue({ workingDays: v })
                    }
                },

                { label: 'Joining Salary', key: 'joiningSalary', type: 'number', style: { width: "100%" } },
                {
                    label: 'Active Status',
                    key: 'activeStatus',
                    type: 'select',
                    options: ['Active', 'Resignation', 'Termination', 'Abscond'],
                    hidden: !this.state.id,
                    placeholder: 'Select Status',
                    onChange: v => {
                        this.setState({ activeStatus: v })
                        this.props.form.setFieldsValue({
                            activeStatus: v
                        })
                    }
                },
                { label: 'Resignation Date', key: 'resignationDate', type: 'date', hidden: (activeStatus == 'Resignation' ? false : true) },
                { label: 'Termination Date', key: 'terminationDate', type: 'date', hidden: (activeStatus == 'Termination' ? false : true) },
                { label: 'Abscond Date', key: 'abscondDate', type: 'date', hidden: (activeStatus == 'Abscond' ? false : true) },
                { label: 'Date Of Relieving', key: 'dateOfRelieving', type: 'date', hidden: !this.state.id, },
                { label: 'Relieving Letter', key: 'relievingCert', type: 'file', hidden: !this.state.id, },
                {
                    label: 'Full And Final Statement Due',
                    key: 'fullFinalSettlementDue',
                    type: 'select',
                    options: ['Pending', 'Cleared'],
                    placeholder: 'Select Status',
                    hidden: !this.state.id,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            fullFinalSettlementDue: v
                        })
                    }
                },
                {
                    label: 'Experience Letter',
                    key: 'experienceLetter',
                    type: 'select',
                    hidden: !this.state.id,
                    options: ['Issued', 'Not Issued'],
                    placeholder: 'Select Option',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            experienceLetter: v
                        })
                        if (v === 'Issued') {
                            this.setState({ expierenceLetterIssued: true })
                        } else if (v === 'Not Issued') {
                            this.setState({ expierenceLetterIssued: false })
                        }
                    }
                },
                {
                    label: 'Experience Certificate',
                    key: 'experienceCert',
                    type: 'file',
                    hidden: !expierenceLetterIssued,
                    required: expierenceLetterIssued
                },
                {
                    label: 'No Due Certificate',
                    key: 'noDueCert',
                    type: 'file',
                    hidden: !this.state.id,
                }
            ]
        }

        const userColumn = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                searchTextName: 'name',
                filterRegex: true,
                sorter: true
            },
            {
                title: 'UserName / Email',
                dataIndex: 'email',
                key: 'email',
                searchTextName: 'email',
                filterRegex: true
            },
            {
                title: 'Branch',
                key: 'userBranch',
                filters: allBranches,
                render: (val, record) => {
                    return (
                        <div>{record.userBranch ? record.userBranch.branchName : ''}</div>
                    )
                }
            },
            {
                title: 'Mobile',
                dataIndex: 'userMobile',
                key: 'userMobile'
            },
            {
                title: 'Joining As A Counsellor',
                dataIndex: 'isCounsellor',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'isCounsellor',
                render: (val, record) => {
                    return <div className={styles.wrap}>
                        <Switch checked={record.isCounsellor}
                            onChange={(checked) => {
                                this.changeUserCounsellor({ checked, _id: record._id })
                            }} />
                    </div>
                }
            },

            {
                title: 'Joining As A Telecaller',
                dataIndex: 'isTelecaller',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'isTelecaller',
                render: (val, record) => {
                    return <div className={styles.wrap}>
                        <Switch checked={record.isTelecaller}
                            onChange={(checked) => {
                                this.assignUserTelecaller({ checked, _id: record._id })
                            }} />
                    </div>
                }
            },

            {
                title: 'Login By OTP Only',
                dataIndex: 'loginByOTPOnly',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'loginByOTPOnly',
                render: (val, record) => {
                    return <div className={styles.wrap}>
                        <Switch checked={record.loginByOTPOnly}
                            onChange={(checked) => {
                                this.changeLoginByOTPOnly({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },

            {
                title: 'Verify IP',
                dataIndex: 'verifyIP',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'verifyIP',
                render: (val, record) => {
                    if (this.state.activeUser && this.state.activeUser.businessId === "1035") {
                        return null;
                    }

                    return <div className={styles.wrap}>
                        <Switch checked={record.verifyIP}
                            onChange={(checked) => {
                                this.changeVerifyIPOnly({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },
            {
                title: 'Profile Updated',
                dataIndex: 'editedByUser',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'editedByUser',
                render: (val, record) => {
                    return <div className={styles.wrap}>
                        <Switch checked={record.editedByUser}
                            onChange={(checked) => {
                                this.changeEditedByUser({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },
            {
                title: 'Operation Manager',
                dataIndex: 'isOperationManager',
                filters: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
                key: 'isOperationManager',
                render: (val, record) => {
                    return <div className={styles.wrap}>
                        <Switch checked={record.isOperationManager}
                            onChange={(checked) => {
                                this.changeIsOperationManager({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },

            {
                title: 'Group',
                key: 'userGroup',
                filters: allUserGroup,
                render: (text, record) => (
                    record.userGroup ? (<React.Fragment>
                        <div
                        >
                            <Tooltip title="Click To View Group Details">
                                <a
                                    className={styles.btn}
                                    target={"_blank"}
                                    href={`/group?id=${record.userGroup._id}`}
                                >
                                    {record.userGroup.groupName}
                                </a>
                            </Tooltip>
                        </div>

                    </React.Fragment>) : ''
                ),
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                width: 130,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <Tooltip title="Update User Status">
                            <Switch checked={record.active}
                                onChange={(checked) => {
                                    this.changeUserApporval({ checked, _id: record._id })
                                }} />
                        </Tooltip>

                        <Tooltip title="Change Password">
                            <Button
                                className={styles.btn}
                                size={'small'}
                                shape="circle"
                                onClick={() => {
                                    this.setState({
                                        changePasswordRecord: record,
                                        drawerVisible: true
                                    })
                                }}
                            ><FaUserCog /></Button>
                        </Tooltip>

                        <Tooltip title="Update User">
                            <Button
                                className={styles.btn}
                                size={'small'}
                                shape="circle"
                                onClick={() => {
                                    dispatch(
                                        getUrlPushWrapper('user.editUser', { id: record._id })
                                    )
                                }}
                                icon="edit"
                            />
                        </Tooltip>

                        <Tooltip title="Login to user account">
                            <Button
                                onClick={() => { this.syncUserSession(record.email) }}
                                className={styles.btn}
                                size={'small'}
                                shape="circle"
                                icon="eye"
                            />
                        </Tooltip>
                    </div>
                )
            },
            {
                title: 'Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'Updated By',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            }
        ];

        const stageTypesOptions = incentiveTypes.filter(stage => -1 == seniorityBonus.findIndex(el => el.type == stage.id));

        const stageTypesOptionsForOperationManager = incentiveTypes.filter(stage => -1 == operationManagerIncentive.findIndex(el => el.operationManagerType == stage.id));

        return (
            <PageHeaderWrapper title={id ? 'Edit User' : 'USER MANAGEMENT'}>
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card bordered={true}>

                        <Tabs onChange={this.callback} type="card">

                            <TabPane tab={id ? 'Edit User' : 'Add User'} key={0}>
                                <GetAllFormFields
                                    apiurl={LAPI_URL}
                                    inputSchema={inputTypes}
                                    refresh={this.refreshFxn}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                />

                                <h2>Bank Details</h2>
                                <GetAllFormFields
                                    apiurl={LAPI_URL}
                                    inputSchema={inputTypeBankDetails}
                                    refresh={this.refreshFxn}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                <h2>Personal Info</h2>
                                <GetAllFormFields
                                    apiurl={LAPI_URL}
                                    inputSchema={inputTypePersonalInfo}
                                    refresh={this.refreshFxn}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}

                                />
                                {/* <h2>Extra Info</h2>
                                <Row className='' style={{ padding: '10px 305px 20px' }}>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 10 }}>
                                                <h4>Seniority Bonus</h4>
                                            </Col>
                                            <Col span={16} >

                                                <Select
                                                    value={type}
                                                    allowClear={true}
                                                    placeholder={"Select Type"}
                                                    disabled={this.state.editIndex != null}
                                                    className={'knowledge-base-input'}
                                                    onChange={(val) => {
                                                        this.setState({ type: val });
                                                    }}
                                                >
                                                    <Option value={null}>Select Type</Option>
                                                    {stageTypesOptions.map((item, key) => {
                                                        return (
                                                            <Option key={key} value={item.id}>{item.display}</Option>
                                                        )
                                                    })}
                                                </Select>

                                                <Input
                                                    value={seniorityBonusFlatAmount}
                                                    placeholder={'Enter Seniority Bonus Flat Amount'}
                                                    className={'knowledge-base-input'}
                                                    onChange={ei => {
                                                        this.setState({
                                                            seniorityBonusFlatAmount: ei.target.value,
                                                        })
                                                    }}
                                                />
                                            </Col>
                                            <Col span={4} style={{ paddingLeft: 10 }}>
                                                {
                                                    this.state.editIndex != null ?
                                                        <Button
                                                            onClick={this.updateStage}>
                                                            Update
                                                        </Button>
                                                        :
                                                        <Button
                                                            onClick={this.addToStages}>
                                                            ADD
                                                        </Button>
                                                }
                                            </Col>
                                        </Row>
                                        <Row >
                                            <Col span={24}>
                                                <List
                                                    style={{ marginLeft: 96 }}
                                                    size="small"
                                                    header={<List.Item>
                                                        <Row style={{ width: '100%' }}>
                                                            <Col span={5}>
                                                                <span style={{ fontWeight: 'bold' }}>Type</span>
                                                            </Col>
                                                            <Col span={7}>
                                                                <span style={{ fontWeight: 'bold' }}>Seniority Bonus Flat Amount</span>
                                                            </Col>
                                                            <Col span={4}>
                                                                <span style={{ fontWeight: 'bold' }}>Action</span>
                                                            </Col>
                                                        </Row>
                                                    </List.Item>}
                                                    bordered
                                                    dataSource={seniorityBonus}
                                                    renderItem={(val, index) => (
                                                        <>
                                                            
                                                            <List.Item>
                                                                <Row style={{ width: '100%' }}>
                                                                    <Col span={5}>
                                                                        {this.renderStatus(val.type)}
                                                                    </Col>
                                                                    <Col span={7} style={{textAlign:'center'}}>
                                                                        {val.seniorityBonusFlatAmount ? val.seniorityBonusFlatAmount : '-'}
                                                                    </Col>
                                                                    <Col span={2}>
                                                                        <a
                                                                            onClick={() =>
                                                                                this.editStages(val, index)
                                                                            }>
                                                                            Edit
                                                                        </a>
                                                                    </Col>
                                                                    <Col span={2}>
                                                                        <a
                                                                            onClick={() =>
                                                                                this.removeIn(index)
                                                                            }>
                                                                            Remove
                                                                        </a>
                                                                    </Col>
                                                                </Row>
                                                            </List.Item>
                                                        </>
                                                    )}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className='' style={{ padding: '10px 305px 20px' }}>

                                    <Col span={24}>
                                        <Row>
                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 10 }}>
                                                <h4>Operation Manager</h4>
                                            </Col>
                                            <Col span={16} >

                                                <Select
                                                    value={operationManagerType}
                                                    allowClear={true}
                                                    placeholder={"Select Type"}
                                                    className={'knowledge-base-input'}
                                                    disabled={this.state.editIndexOperationManager != null}
                                                    onChange={(val) => {
                                                        this.setState({ operationManagerType: val });
                                                    }}
                                                >
                                                    <Option value={null}>Select Type</Option>
                                                    {stageTypesOptionsForOperationManager.map((item, key) => {
                                                        return (
                                                            <Option key={key} value={item.id}>{item.display}</Option>
                                                        )
                                                    })}
                                                </Select>

                                                <Input
                                                    value={operationManagerFlatAmount}
                                                    placeholder={'Enter Operation Manager Flat Amount'}
                                                    className={'knowledge-base-input'}
                                                    onChange={ei => {
                                                        this.setState({
                                                            operationManagerFlatAmount: ei.target.value,
                                                        })
                                                    }}
                                                />
                                            </Col>
                                            <Col span={4} style={{ paddingLeft: 10 }}>
                                                {
                                                    this.state.editIndexOperationManager != null ?
                                                        <Button
                                                            onClick={this.updateOperationManageStage}>
                                                            Update
                                                        </Button>
                                                        :
                                                        <Button
                                                            onClick={this.addToOperationManagerStages}>
                                                            ADD
                                                        </Button>
                                                }
                                            </Col>
                                        </Row>
                                        <Row >
                                            <Col span={24}>
                                                <List
                                                    style={{ marginLeft: 96 }}
                                                    size="small"
                                                    header={<List.Item>
                                                        <Row style={{ width: '100%' }}>
                                                            <Col span={5}>
                                                                <span style={{ fontWeight: 'bold' }}>Type</span>
                                                            </Col>
                                                            <Col span={7}>
                                                                <span style={{ fontWeight: 'bold' }}>Operation Manager Flat Amount</span>
                                                            </Col>
                                                            <Col span={4}>
                                                                <span style={{ fontWeight: 'bold' }}>Action</span>
                                                            </Col>
                                                        </Row>
                                                    </List.Item>}
                                                    bordered
                                                    dataSource={operationManagerIncentive}
                                                    renderItem={(val, index) => (
                                                        <>                                                            
                                                            <List.Item>
                                                                <Row style={{ width: '100%' }}>
                                                                    <Col span={5}>
                                                                        {this.renderStatus(val.operationManagerType)}
                                                                    </Col>
                                                                    <Col span={7} style={{textAlign:'center'}}>
                                                                        {val.operationManagerFlatAmount ? val.operationManagerFlatAmount : '-'}
                                                                    </Col>
                                                                    <Col span={2}>
                                                                        <a
                                                                            onClick={() =>
                                                                                this.editOperationManagerStages(val, index)
                                                                            }>
                                                                            Edit
                                                                        </a>
                                                                    </Col>
                                                                    <Col span={2}>
                                                                        <a
                                                                            onClick={() =>
                                                                                this.removeOperationMangerIncentive(index)
                                                                            }>
                                                                            Remove
                                                                        </a>
                                                                    </Col>
                                                                </Row>
                                                            </List.Item>
                                                        </>
                                                    )}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row> */}
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </TabPane>
                            <TabPane tab={`All Users `} key={1} disabled={!!id}>
                                <h2>{`Users : ${this.state.totalUser}`}
                                    <Button
                                        className={styles.btn1}
                                        type="primary"
                                        onClick={() => {
                                            this.state.isActive = !this.state.isActive
                                            this.setState({ isActive: this.state.isActive })
                                            this.onOk()
                                        }}> {this.state.isActive ? 'All Users' : 'Active Users'}
                                    </Button>
                                </h2>

                                <TableComp
                                    columns={userColumn}
                                    ref={this.table}
                                    extraProps={{ scroll: { x: 1600 } }}
                                    apiRequest={params => this.loadUsers(params, 'user')}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 200,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </TabPane>

                        </Tabs>
                    </Card>
                </Form>
                <Drawer
                    title="View User Profile"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            openUserSessionDrawr: false
                        })
                    }}
                    visible={openUserSessionDrawr}
                    width={800}>
                    <div className={styles.drawerWrapper}>
                        <div style={{ textAlign: 'center', padding: 20, fontSize: 18 }}>
                            <small>Copy this URL to a different browser to login as another user and keep your session continued</small>
                            <Input
                                value={loginUrl}
                                type='text'
                                className='form-control'
                                id='webLinkCopy'
                                style={{ cursor: 'pointer' }}
                                readOnly
                                onClick={() => {
                                    var copyText = document.getElementById("webLinkCopy");
                                    copyText.select();
                                    copyText.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(copyText.value);
                                    notification.success({ message: "Copied To Clipboard." })
                                }}
                            />
                        </div>
                    </div>
                </Drawer>
                <Drawer
                    title="Change Password"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            drawerVisible: false
                        })
                    }}
                    visible={drawerVisible}
                    width={400}>
                    <div className={styles.drawerWrapper}>
                        <div style={{ textAlign: 'center', padding: 20, fontSize: 18 }}>
                            Change Password for
                            {changePasswordRecord && <b> {changePasswordRecord.name}</b>}
                        </div>

                        <ChangePassword
                            loading={this.props.loading}
                            handleSubmit={async values => {
                                if (values.password !== values.cpassword) {
                                    notification.error({
                                        message: 'Unable to Match Passwords'
                                    })
                                    return false
                                }

                                if (values.password.length < 6) {
                                    notification.error({
                                        message: 'Password too Small'
                                    })
                                    return false
                                }

                                dispatch(showLoader())

                                let x = await Request.changeUserPassword({
                                    _id: changePasswordRecord._id,
                                    password: values.password
                                })

                                if (x.error) {
                                    notification.success({
                                        message: 'User not found',
                                        description: x.msg
                                    })
                                } else {
                                    notification.success({
                                        message: 'Password Changes Successfully'
                                    })
                                }

                                this.setState({
                                    changePasswordRecord: null,
                                    drawerVisible: false
                                })
                                dispatch(hideLoader())
                            }}
                        />
                    </div>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(User)
